'use strict';

module.exports = [require('./apply'), require('./column'), require('./concat'), require('./cross'), require('./ctranspose'), require('./det'), require('./diag'), require('./dot'), require('./eye'), require('./expm'), require('./filter'), require('./flatten'), require('./forEach'), require('./identity'), require('./inv'), require('./kron'), require('./map'), require('./ones'), require('./partitionSelect'), require('./range'), require('./reshape'), require('./resize'), require('./row'), require('./size'), require('./sort'), require('./sqrtm'), require('./squeeze'), require('./subset'), require('./trace'), require('./transpose'), require('./zeros'), require('./getMatrixDataType')];


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/matrix/index.js
// module id = 1089
// module chunks = 0